<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 90vw">
      <!-- HEADER -->
      <div class="modal-header">
        <h5 class="modal-title">Acertain Bill and Quantity to Invoice Insurance</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <!-- BODY -->
      <div class="modal-body">
        <table class="table">
          <thead class="p-0 m-0" style="padding: 0; margin: 0">
            <tr class="p-0 m-0" style="padding: 0; margin: 0">
              <th scope="col" class="p-0 m-0">Service/Product</th>
              <th scope="col" class="p-0 m-0">Quantity</th>
              <th scope="col" class="p-0 m-0">Unit Price</th>
              <th scope="col" class="p-0 m-0">Amount</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>{{ bill.charge_name }}</td>

              <td>
                <input
                  type="number"
                  min="1"
                  class="form-control"
                  v-model.number="modified_bill.quantity"
                  @input="updateAmount"
                />
              </td>

              <td>{{ bill.unit_price }}</td>

              <td>{{ modified_bill.amount_due }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- FOOTER -->
      <div class="modal-footer">
        <!-- <button class="btn btn-secondary" @click="closeModal">Close</button> -->
        <button class="btn btn-primary" @click="saveChanges">Ok</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalContent",

  props: {
    bill: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      modified_bill: {
        ...this.bill, // copy of the original bill
        quantity: this.bill.quantity,
        amount_due: this.bill.amount_due,
      },
    };
  },

  methods: {
    closeModal() {
      this.$emit("close-pro");
    },

    saveChanges() {
      // Instead of mutating the prop, emit the updated object
      this.$emit("send-update", {
        ...this.modified_bill,
      });
      this.closeModal();
    },

    updateAmount() {
      const qty = Number(this.modified_bill.quantity) || 1;
      const price = Number(this.bill.unit_price) || 0;

      this.modified_bill.amount_due = qty * price;
    },
  },

  mounted() {
    console.log("Modal opened with bill:", this.bill);
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
